// extracted by mini-css-extract-plugin
export var button = "_jr-2";
export var card = "_jr-0";
export var closeButtonContainer = "_jr-3";
export var iconContainer = "_jr-1";